export { ANSWER_SOURCES, POLICY_EVALUATION_ANSWER_SOURCE, } from './validation.js';
export var Category;
(function (Category) {
    Category["HIGH_PRIORITY_FIX"] = "high-priority-fix";
    Category["TOP_PRIORITY"] = "top-priority";
    Category["IMPROVE_PRACTICE"] = "improve-practice";
    Category["EASY_FIX"] = "easy-fix";
})(Category || (Category = {}));
//# sourceMappingURL=types.js.map